function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import _ from 'lodash';
import { flattenedIntegrationsForSegment } from './integrations';
import { isSuperAdmin } from './users';
export var buildSuperAdminTraits = function() {
    return {
        name: 'dutchie',
        tags: 'dispensary_user_segment'
    };
};
export var buildIntegrationsTraits = function(dispoIntegrations) {
    var allIntegrations = flattenedIntegrationsForSegment();
    _.forEach(dispoIntegrations, function(integration) {
        allIntegrations[integration.adapter] = integration.live;
    });
    return allIntegrations;
};
export var buildDispensaryTraits = function(dispensary) {
    var _dispensary_location, _dispensary_location1, _dispensary_location2, _dispensary_location3;
    return {
        chain_id: dispensary === null || dispensary === void 0 ? void 0 : dispensary.chain,
        city: dispensary === null || dispensary === void 0 ? void 0 : (_dispensary_location = dispensary.location) === null || _dispensary_location === void 0 ? void 0 : _dispensary_location.city,
        country: dispensary === null || dispensary === void 0 ? void 0 : (_dispensary_location1 = dispensary.location) === null || _dispensary_location1 === void 0 ? void 0 : _dispensary_location1.country,
        embedded: !_.isEmpty(dispensary === null || dispensary === void 0 ? void 0 : dispensary.embeddedMenuUrl),
        id: dispensary === null || dispensary === void 0 ? void 0 : dispensary.id,
        name: dispensary === null || dispensary === void 0 ? void 0 : dispensary.name,
        phone: dispensary === null || dispensary === void 0 ? void 0 : dispensary.phone,
        postalCode: dispensary === null || dispensary === void 0 ? void 0 : (_dispensary_location2 = dispensary.location) === null || _dispensary_location2 === void 0 ? void 0 : _dispensary_location2.zipcode,
        state: dispensary === null || dispensary === void 0 ? void 0 : (_dispensary_location3 = dispensary.location) === null || _dispensary_location3 === void 0 ? void 0 : _dispensary_location3.state,
        subdomain: !_.isEmpty(dispensary === null || dispensary === void 0 ? void 0 : dispensary.customDomainSettings),
        status: dispensary === null || dispensary === void 0 ? void 0 : dispensary.status,
        tags: 'dispensary_user_segment',
        tier: dispensary === null || dispensary === void 0 ? void 0 : dispensary.tier,
        timezone: dispensary === null || dispensary === void 0 ? void 0 : dispensary.timezone
    };
};
export var buildTraitsFromUser = function(user) {
    var traits = {
        createdAt: user.createdAt,
        email: _.get(user, 'emails[0].address'),
        firstName: user.profile.firstName,
        lastName: user.profile.lastName,
        name: user.profile.fullName,
        phone: user.profile.phone
    };
    // flatten permissions
    _.merge(traits, user.profile.permissions);
    return traits;
};
function getEnvIdentifier(id) {
    return window.reactEnv.appEnv === 'production' ? id : 'developmentId';
}
export var segmentIdentifyAndGroup = function(user, dispensary, integrations) {
    if (!window.analytics || !user) {
        return;
    }
    var userId = getEnvIdentifier(user._id);
    // in all cases at least call identify on the user
    window.analytics.identify(userId, _object_spread({}, buildTraitsFromUser(user)));
    // if user is super admin, we want to add them to the dutchie org in zendesk
    if (isSuperAdmin(user)) {
        window.analytics.group('superAdminId', _object_spread({}, buildSuperAdminTraits()));
    }
    // when dispensary data is provided, we can group it into an org downstream
    if (dispensary) {
        var traits = buildDispensaryTraits(dispensary);
        var dispoId = getEnvIdentifier(dispensary.id);
        if (integrations) {
            traits = _object_spread({}, traits, buildIntegrationsTraits(integrations));
        }
        window.analytics.group(dispoId, traits);
    }
};
export var openZendeskWidget = function() {
    if (_.isFunction(window.zE)) {
        try {
            window.zE('webWidget', 'open');
        } catch (e) {
            window.zE('messenger', 'open');
        }
    }
};
export var showZendeskWidget = function() {
    if (_.isFunction(window.zE)) {
        try {
            window.zE('webWidget', 'show');
        } catch (e) {
            window.zE('messenger', 'open');
        }
    }
};
export var hideZendeskWidget = function() {
    if (_.isFunction(window.zE)) {
        try {
            window.zE('webWidget', 'hide');
        } catch (e) {
            window.zE('messenger', 'close');
        }
    }
};
export var closeZendeskWidget = function() {
    if (_.isFunction(window.zE)) {
        hideZendeskWidget();
        // run this no matter what but also it can throw exceptions
        try {
            window.zE('messenger', 'close');
        } catch (e) {
        // no-op — messenger may already be closed
        }
    }
};
export function hideDecagonWidget() {
    if (!window.duet) {
        return;
    }
    window.duet.hide();
}
export function showDecagonWidget() {
    if (!window.duet) {
        return;
    }
    window.duet.unhide();
}
export function openDecagonWidget() {
    if (!window.duet) {
        return;
    }
    window.duet.unhide();
    window.duet.open();
}
export function closeDecagonWidget() {
    if (!window.duet) {
        return;
    }
    window.duet.close();
}
export function openChatWidget() {
    openZendeskWidget();
    openDecagonWidget();
}
